import { discountConfig } from "~/config";
import { priceFormat } from "@/utils";

export const state = () => ({
  regularCartInfo: null,
  checkoutCartInfo: null,
  globalCheckoutLoader: false,
  loadingDiscountCode: false,
  errorDiscountCode: false,
  discountCode: "",
  removingIdsLoading: [],
});

export const getters = {
  getCartItems(state, getters) {
    return getters.getCartInfo?.items || [];
  },
  getRegularCartInfo(state) {
    return state.regularCartInfo;
  },
  getCheckoutCartInfo(state) {
    return state.checkoutCartInfo;
  },
  getCartInfo(state) {
    return state.checkoutCartInfo || state.regularCartInfo;
  },
  getCartItemsCount(state, getters) {
    const items = getters.getCartItems;
    return items.reduce((acc, item) => {
      return acc + Number(item.quantity) || 0;
    }, 0);
  },

  getCartItemsDigital(state, getters) {
    const items = getters.getCartItems;
    return items.filter((item) => item.digital) || [];
  },

  getHasOnlyDigitalItemsInCart(state, getters) {
    return getters.getCartItems.length === getters.getCartItemsDigital.length;
  },

  getGlobalCheckoutLoader(state) {
    return state.globalCheckoutLoader;
  },

  getRemovingIdsLoading(state) {
    return state.removingIdsLoading;
  },

  // getGiftCard(state) {
  //   return state.regularCartInfo?.gift_card || null;
  // },

  // getDiscountCard(state) {
  //   const discountCard = state.regularCartInfo?.sale || state.regularCartInfo?.discount;
  //   return discountCard
  //     ? {
  //         ...discountCard,
  //         is_automatic: !!state.regularCartInfo.sale,
  //       }
  //     : null;
  // },

  // getDiscountSource(state, getters) {
  //   return getters.getGiftCard || getters.getDiscountCard;
  // },

  // isProductsDiscount(state, getters) {
  //   return (
  //     (getters.getDiscountCard &&
  //       getters.getCartItems.some((item) => item.discount)) ||
  //     getters.getCartItems.some((item) =>
  //       item.sub_items?.some((subItem) => subItem.discount)
  //     )
  //   );
  // },

  // getDiscountProductsSubtotal(state, getters) {
  //   return getters.getCartItems.reduce((acc, item) => {
  //     if (item.discount) {
  //       acc += Number(item.base_amount) * (item.quantity || 1);
  //     }
  //     if (item.sub_items?.some((subItem) => subItem.discount)) {
  //       acc += item.sub_items.reduce((subAcc, subItem) => {
  //         if (subItem.discount) {
  //           subAcc += Number(subItem.base_amount) * (item.quantity || 1);
  //         }
  //         return subAcc;
  //       });
  //     }
  //     return acc;
  //   }, 0);
  // },

  // getFixedProductsTotalDiscountSum(state, getters) {
  //   return getters.getCartItems.reduce((acc, item) => {
  //     if (item.discount) {
  //       const discountAmount =
  //         Number(item.discount.amount) < Number(item.base_amount)
  //           ? Number(item.discount.amount)
  //           : Number(item.base_amount);
  //       acc += discountAmount * (item.quantity || 1);
  //     }
  //     if (item.sub_items?.some((subItem) => subItem.discount)) {
  //       acc += item.sub_items.reduce((subAcc, subItem) => {
  //         if (subItem.discount) {
  //           const discountAmount =
  //             Number(subItem.discount.amount) < Number(subItem.base_amount)
  //               ? Number(subItem.discount.amount)
  //               : Number(subItem.base_amount);
  //           subAcc += discountAmount * (item.quantity || 1);
  //         }
  //         return subAcc;
  //       });
  //     }
  //     return acc;
  //   }, 0);
  // },
  getDiscountItems(state, getters) {
    return (data) => {
      if (data?.options?.discounts) {
        return Object.values(data.options.discounts);
      }
      return [];
    };
  },
  getGiftCardItems(state, getters) {
    return (data) => {
      if (data?.options?.gift_cards) {
        return Object.values(data.options.gift_cards);
      }
      return [];
    };
  },
  getDiscountValue(state, getters, rootState) {
    return (item) => {
      switch (item.discount_type) {
        case discountConfig.type.static:
          return `-${priceFormat(
            item.used_discount_amount,
            rootState.general?.settings?.currency_sign
          )}`;
        case discountConfig.type.percent:
          return `-${priceFormat(
            item.used_discount_amount,
            rootState.general?.settings?.currency_sign
          )}(${item.base_discount_amount}%)`;
        default:
          return null;
      }
    };
  },
  getGiftCardValue(state, getters, rootState) {
    return (item) => {
      switch (item.gift_card_type) {
        case discountConfig.type.static:
          return `-${priceFormat(
            item.used_gift_card_amount,
            rootState.general?.settings?.currency_sign
          )}`;
        case discountConfig.type.percent:
          return `-${priceFormat(
            item.used_gift_card_amount,
            rootState.general?.settings?.currency_sign
          )}(${item.base_gift_card_amount}%)`;
        default:
          return null;
      }
    };
  },
  getLoadingDiscountCode(state) {
    return state.loadingDiscountCode;
  },
  getErrorDiscountCode(state) {
    return state.errorDiscountCode;
  },
  getDiscountCode(state) {
    return state.discountCode;
  },
};

export const mutations = {
  SET_CART_INFO(state, payload) {
    state.regularCartInfo = payload;
  },
  SET_CHECKOUT_CART_INFO(state, payload) {
    state.checkoutCartInfo = payload;
  },
  RESET_CART(state) {
    state.regularCartInfo = null;
    state.checkoutCartInfo = null;
  },
  SET_GLOBAL_CHECKOUT_LOADER(state, payload) {
    state.globalCheckoutLoader = payload;
  },
  SET_LOADING_DISCOUNT_CODE(state, payload) {
    state.loadingDiscountCode = payload;
  },
  SET_ERROR_DISCOUNT_CODE(state, payload) {
    state.errorDiscountCode = payload;
  },
  SET_DISCOUNT_CODE(state, payload) {
    state.discountCode = payload;
  },
  SET_REMOVING_IDS_LOADING(state, payload) {
    state.removingIdsLoading = payload;
  },
};

export const actions = {
  async updateCartItem({ commit, dispatch, rootState, getters }, item) {
    const params = {
      cart_unique_id: getters.getCartInfo.unique_id,
      ...item,
    };
    try {
      const { data } = await this.$api.cart.updateCartItem(item.id, params);
      dispatch("setCartInfo", data.data);
    } catch (e) {
      console.log(e);
    }
  },
  async removeCartItem(
    { commit, getters, dispatch, rootState, rootGetters, state },
    id
  ) {
    const cartId = getters.getCartInfo.unique_id;
    const params = {
      cart_unique_id: cartId,
    };
    commit("SET_REMOVING_IDS_LOADING", [
      ...new Set([...state.removingIdsLoading, id]),
    ]);
    try {
      await this.$api.cart.deleteCartItem(id, params);

      const userInfo = rootGetters["auth/getUserInfo"];

      const { data } = await this.$api.cart.getCart({ cartId, userInfo });
      dispatch("setCartInfo", data.data);
      // await dispatch("getCart");
      // const items = getters.getCartItems.filter((i) => i.id !== id);
      // commit("SET_CART_INFO", {
      //   ...this.cartInfo,
      //   items,
      // });
    } catch (e) {
      console.log(e);
    } finally {
      commit(
        "SET_REMOVING_IDS_LOADING",
        state.removingIdsLoading.filter((i) => i !== id)
      );
    }
  },

  async bindDiscount({ commit, getters, dispatch, rootState }, code) {
    if (!getters?.getCartInfo?.unique_id) return;
    const params = {
      cart_unique_id: getters.getCartInfo.unique_id,
      gift_card_code: code,
    };
    try {
      const { data } = await this.$api.cart.bindDiscount(params);
      dispatch("setCartInfo", data.data);
      return Promise.resolve(data.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async unbindDiscount({ commit, getters, dispatch, rootState }, code) {
    if (!getters?.getCartInfo?.unique_id) return;
    const params = {
      cart_unique_id: getters.getCartInfo.unique_id,
      gift_card_code: code,
    };
    try {
      const { data } = await this.$api.cart.unbindDiscount(params);
      dispatch("setCartInfo", data.data);
      return Promise.resolve(data.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async getCheckoutCart({ commit }, cartUniqueId) {
    if (!cartUniqueId) return null;
    try {
      const { data } = await this.$api.checkout.getCheckoutCart({
        cart_unique_id: cartUniqueId,
      });
      commit("SET_CHECKOUT_CART_INFO", data.data);
      return Promise.resolve(data.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  setCheckoutCartInfo({ state, commit }, payload) {
    if (this.$broadcastChannel) {
      this.$broadcastChannel.postMessage({
        type: "UPDATE_CHECKOUT_CART",
        method: "UPDATE",
        data: {
          cart: payload,
          old_unique_id: state.checkoutCartInfo?.unique_id,
        },
      });
    }
    commit("SET_CHECKOUT_CART_INFO", payload);
  },

  setRegularCartInfo({ commit }, payload) {
    if (this.$broadcastChannel) {
      this.$broadcastChannel.postMessage({
        type: "UPDATE_CART",
        method: "UPDATE",
        data: {
          cart: payload,
          old_unique_id: state.regularCartInfo?.unique_id,
        },
      });
    }
    commit("SET_CART_INFO", payload);
  },

  setCartInfo({ state, dispatch, commit, rootGetters }, payload) {
    if (
      payload?.unique_id &&
      payload?.unique_id !== rootGetters.getCartId &&
      payload?.unique_id !== state.checkoutCartInfo?.unique_id &&
      payload?.unique_id !== state.regularCartInfo?.unique_id
    ) {
      commit("SET_LOCAL_VAR", {
        var: "cart_unique_id",
        val: payload.unique_id,
      }, { root: true });
    }
    if (state.checkoutCartInfo) {
      dispatch("setCheckoutCartInfo", payload);
      if (
        state.checkoutCartInfo.unique_id === state.regularCartInfo?.unique_id
      ) {
        dispatch("setRegularCartInfo", payload);
      }
    } else {
      dispatch("setRegularCartInfo", payload);
    }
  },
};
